import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=39525b8b&scoped=true&"
import script from "./VideoGallery.vue?vue&type=script&lang=ts&"
export * from "./VideoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=39525b8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39525b8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow,VSheet})
